import { render } from "./VoucherSavePage.vue?vue&type=template&id=b52ec974"
import script from "./VoucherSavePage.vue?vue&type=script&lang=js"
export * from "./VoucherSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script